module.exports = __webpack_public_path__ + "static/img/mongodb.2318514.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/mongodb.jpg
// module id = DP68
// module chunks = 1